export const defaultConfig = {
  sectionSelectors: '.o-container, .o-container-fluid, .contact-form',
  button: {
    selector:
      'button:not(.c-accordion__toggle, .slick-arrow, .c-nav-header-toggle)',
  },
  carousel: {
    disabled: false,
    selector: '.slick-arrow',
  },
  menu: {
    disabled: false,
    selector: '.c-nav-header-toggle',
  },
  formTracking: {
    disabled: false,
    selector: 'form',
    nameFieldSelector: '[name="custom-event-id"]',
    errorFieldSelector: '.form__error, .error',
    additionalFields: [
      {
        name: 'donation_value',
        selector: '[name=final_amount]',
      },
      {
        name: 'donation_frequency',
        selector: '[name=donate-frequency]',
      },
      {
        name: 'donation_dollar_handle',
        selector: '[name=donate-value]:checked',
      },
      {
        name: 'can_remarket',
        selector: '[name=can-remarket]',
      },
    ],
  },
};
